module.exports = __webpack_public_path__ + "static/media/MANA.aecf42b4.png";